import * as THREE from 'three';
import { markInteractive } from './BaseComponent';

export class Wire extends THREE.Group {
  private material: THREE.MeshStandardMaterial;
  private particles: THREE.Points | null = null;
  private path: THREE.CatmullRomCurve3;
  private flow = 0;

  constructor(id: string, name: string, points: THREE.Vector3[], color: number, tubularSegments = 32, interactive = true) {
    super();
    this.name = name;
    this.path = new THREE.CatmullRomCurve3(points);
    this.material = new THREE.MeshStandardMaterial({ color, emissive: color, emissiveIntensity: 0.08, roughness: 0.44 });
    const tube = new THREE.Mesh(new THREE.TubeGeometry(this.path, tubularSegments, 0.075, 7, false), this.material);
    tube.castShadow = true;
    this.add(tube);
    if (interactive) markInteractive(this, {
      id, name, english: 'Circuit Wire', model: id,
      function: name.includes('VCC') ? '传送正电源。' : name.includes('GND') ? '提供 0V 参考与回流路径。' : '传送当前逻辑电平。',
      connection: `${points.length} 个程序化路径节点，连接对应电路端点。`,
      mistake: '接错节点会导致无输出或电源短路。',
      tip: '红=VCC，黑=GND，黄=A，绿=B，蓝=Y，橙=LED 电流路径。'
    });
  }

  setSignal(high: boolean): void {
    this.material.emissiveIntensity = high ? 0.95 : 0.04;
    this.material.opacity = high ? 1 : 0.65;
    this.material.transparent = !high;
  }

  enableFlow(enabled: boolean, count: number): void {
    if (!enabled) {
      if (this.particles) this.particles.visible = false;
      return;
    }
    if (!this.particles) {
      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.Float32BufferAttribute(new Float32Array(count * 3), 3));
      this.particles = new THREE.Points(geometry, new THREE.PointsMaterial({
        color: 0xffb237, size: 0.18, transparent: true, opacity: 0.9, depthWrite: false, blending: THREE.AdditiveBlending
      }));
      this.add(this.particles);
    }
    this.particles.visible = true;
  }

  update(delta: number): void {
    if (!this.particles?.visible) return;
    this.flow = (this.flow + delta * 0.18) % 1;
    const attr = this.particles.geometry.getAttribute('position') as THREE.BufferAttribute;
    for (let i = 0; i < attr.count; i++) {
      const p = this.path.getPointAt((this.flow + i / attr.count) % 1);
      attr.setXYZ(i, p.x, p.y, p.z);
    }
    attr.needsUpdate = true;
  }
}
